// KPI
export const GET_KPI_REQUEST= 'GET_KPI_REQUEST';
export const GET_BILLING_KPI_SUCCESS= 'GET_BILLING_KPI_SUCCESS';
export const GET_BILLING_KPI_FAIL= 'GET_BILLING_KPI_FAIL';

export const GET_INSIGHTS_SUCCESS= 'GET_INSIGHTS_SUCCESS';
export const GET_INSIGHTS_FAIL= 'GET_INSIGHTS_FAIL';

export const UPDATE_OCCUPANCY_COST= 'UPDATE_OCCUPANCY_COST';